module.exports = __webpack_public_path__ + "img/H5-8.f9414fc1.png";